export const educationData = [
    {
        id: 1,
        institution: 'Govt. Post Graduate College Bhakkar',
        course: 'Higher Secondary Education',
        startYear: '2015',
        endYear: '2017'
    },
    {
        id: 2,
        institution: 'University of Sargodha',
        course: 'Bachelor of Information Technology',
        startYear: '2017',
        endYear: '2021'
    },
    
]